




















import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions } from "vuex";
import * as a_ecr from "@/store/modules/FitnessStatisticsModule/actions";

// Model
import { EcrDefinitionsInfo } from "@/model/data/ecr/EcrDefinitionsInfo";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
        };
    },
    computed: {
        ...mapState({
            availableEcrCodes: (state: RootState): EcrDefinitionsInfo[] => state.fitnessStatistics.availableEcrCodes,
        }),
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
    methods: {
        ...mapActions([a_ecr.GET_AVAILABLE_ECR_CODES]),
    },
    async mounted() {
        this.loading = true;
        if (this.availableEcrCodes == null || this.availableEcrCodes.length == 0) await this[a_ecr.GET_AVAILABLE_ECR_CODES]();
        this.loading = false;
    },
});
